import { Select } from './Primitives/Select'
import { Pagination } from './Table/Pagination'

type PaginationBarProps = {
  currentPage: number
  totalCountOfRegisters: number
  registersPerPage: number
  perPageOptions?: number[]
  siblingsCount?: number
  onPageChange: (pageNumber: number) => void
  onChangingRegistersPerPage: (registersPerPage: number) => any
}

export const PaginationBar = ({
  currentPage,
  totalCountOfRegisters,
  registersPerPage,
  perPageOptions = [5, 10, 15, 20, 50],
  onPageChange,
  onChangingRegistersPerPage,
}: PaginationBarProps) => {
  const lastPage = Math.ceil(totalCountOfRegisters / registersPerPage)

  return (
    <div className="flex flex-col gap-8 px-6 md:flex-row md:items-center md:gap-4 md:justify-between">
      <div className="flex items-center justify-between grow">
        <span className="text-sm text-[#333]">
          Página {lastPage === 0 ? 0 : currentPage} de {lastPage}
        </span>

        <div className="w-48">
          <Select
            defaultValue={String(registersPerPage)}
            onValueChange={(registersPerPage) =>
              onChangingRegistersPerPage(Number(registersPerPage))
            }
            options={perPageOptions.map((perPageOption) => ({
              value: String(perPageOption),
              label: `${perPageOption} itens por página`,
            }))}
          />
        </div>
      </div>

      <Pagination
        currentPage={currentPage}
        registersPerPage={registersPerPage}
        totalCountOfRegisters={totalCountOfRegisters}
        onPageChange={onPageChange}
      />
    </div>
  )
}
